// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { useParams, useNavigate, Link } from "react-router-dom";
// import config from "../../config";

// function ServiceDetails() {
//   const { id } = useParams();
//   const [service, setService] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [activeLanguage, setActiveLanguage] = useState("en");
//   const navigate = useNavigate();

//   const fetchServiceDetails = async () => {
//     try {
//       const response = await axios.get(`${config.BASE_URL}/api/admin/services/${id}`, {
//         withCredentials: true,
//       });
//       setService(response.data.data || response.data);
//     } catch (err) {
//       setError("Failed to fetch service details");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchServiceDetails();
//   }, [id]);

//   const handleDelete = async () => {
//     try {
//       await axios.delete(`${config.BASE_URL}/api/admin/delete-service/${id}`, {
//         withCredentials: true,
//       });
//       navigate("/admin/services");
//     } catch (err) {
//       setError("Failed to delete the service");
//     }
//   };

//   if (loading) return <p>Loading...</p>;
//   if (error) return <p>{error}</p>;
//   if (!service) return <p>No service data found.</p>;

//   const langData = activeLanguage === "es" && service.spanishData ? service.spanishData : service;

//   return (
//     <div className="dashboard service_detail_wrap">
//       <div className="container">
//         <h1 className="dash_title">Service Details</h1>
//         <div className="back_btn_wrap">
//           <button className="back-btn" onClick={() => navigate(-1)}>
//             Go Back
//           </button>
//         </div>

//         <div className="main-section">
//           <div className="projects-inner">
//             {/* 🌐 Language Tabs */}
//             <div className="language-tabs" style={{ marginBottom: "20px" }}>
//               <button
//                 className={`language-tab ${activeLanguage === "en" ? "active" : ""}`}
//                 onClick={() => setActiveLanguage("en")}
//                 style={{
//                   padding: "10px 20px",
//                   marginRight: "10px",
//                   border: "1px solid #ddd",
//                   background: activeLanguage === "en" ? "#007bff" : "#fff",
//                   color: activeLanguage === "en" ? "#fff" : "#333",
//                   cursor: "pointer",
//                   borderRadius: "4px",
//                 }}
//               >
//                 English
//               </button>
//               <button
//                 className={`language-tab ${activeLanguage === "es" ? "active" : ""}`}
//                 onClick={() => setActiveLanguage("es")}
//                 style={{
//                   padding: "10px 20px",
//                   border: "1px solid #ddd",
//                   background: activeLanguage === "es" ? "#007bff" : "#fff",
//                   color: activeLanguage === "es" ? "#fff" : "#333",
//                   cursor: "pointer",
//                   borderRadius: "4px",
//                 }}
//               >
//                 Spanish
//               </button>
//             </div>

//             {/* 🏠 Hero Section */}
//             <div className="detail_item">
//               <h2>Hero Section ({activeLanguage === "en" ? "English" : "Spanish"})</h2>
//               <div className="detail_item_inner">
//                 <p><b>Title:</b> {langData?.hero?.title || "—"}</p>
//                 <p><b>Subtitle:</b> {langData?.hero?.subtitle || "—"}</p>
//                 <p><b>Paragraphs:</b> {Array.isArray(langData?.hero?.paragraphs)
//                   ? langData.hero.paragraphs.join(", ")
//                   : "—"}
//                 </p>
//                 {langData?.hero?.fileUrl && (
//                   <div className="banner_img_wrap">
//                     <img
//                       src={`${config.BASE_URL}${langData.hero.fileUrl}`}
//                       alt="Hero"
//                       style={{ maxWidth: "400px", borderRadius: "8px", marginTop: "10px" }}
//                     />
//                   </div>
//                 )}
//               </div>
//             </div>

//             {/* 📊 Statistics Section */}
//             <div className="detail_item">
//               <h2>Statistics ({activeLanguage === "en" ? "English" : "Spanish"})</h2>
//               <div className="detail_item_inner">
//                 <div>
//                   <h4>LED Strips</h4>
//                   <p><b>Number:</b> {langData?.statistics?.ledStrips?.number || "—"}</p>
//                   <p><b>Description:</b> {langData?.statistics?.ledStrips?.description || "—"}</p>
//                 </div>
//                 <div style={{ marginTop: "10px" }}>
//                   <h4>Retail Space</h4>
//                   <p><b>Number:</b> {langData?.statistics?.retailSpace?.number || "—"}</p>
//                   <p><b>Description:</b> {langData?.statistics?.retailSpace?.description || "—"}</p>
//                 </div>
//               </div>
//             </div>

//             {/* 🧱 Projects Section */}
//             <div className="detail_item">
//               <h2>Projects Linked</h2>
//               <div className="detail_item_inner">
//                 {Array.isArray(service.projects) && service.projects.length > 0 ? (
//                   service.projects.map((proj, index) => (
//                     <div key={index} style={{ borderBottom: "1px solid #eee", marginBottom: "10px" }}>
//                       <p><b>Project ID:</b> {proj?.project?._id || proj?.project}</p>
//                       <p><b>Project Name:</b> {proj?.project?.title || "Untitled"}</p>
//                       <p><b>Priority Number:</b> {proj?.prioritNumber || "—"}</p>
//                       <Link to={`/admin/project/${proj?.project?._id}`} style={{ color: "#007bff" }}>
//                         View Project →
//                       </Link>
//                     </div>
//                   ))
//                 ) : (
//                   <p>No projects linked to this service.</p>
//                 )}
//               </div>
//             </div>

//             {/* ⚙️ Action Buttons */}
//             <div className="detail_project_btn_wrap">
//               <div className="detail_edit_del">
//                 <div className="btn_item">
//                   <button className="detail_btns" onClick={handleDelete}>Delete</button>
//                 </div>
//                 <div className="btn_item">
//                   <Link to={`/admin/update-service/${service._id}`} className="update_detail detail_btns">
//                     Edit
//                   </Link>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default ServiceDetails;



import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate, Link } from "react-router-dom";
import config from "../../config";

function ServiceDetails() {
  const { id } = useParams();
  const [service, setService] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [activeLanguage, setActiveLanguage] = useState("en");
  const navigate = useNavigate();

  const fetchServiceDetails = async () => {
    try {
      const response = await axios.get(`${config.BASE_URL}/api/admin/services/${id}`, {
        withCredentials: true,
      });
      setService(response.data.data || response.data);
    } catch (err) {
      setError("Failed to fetch service details");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchServiceDetails();
  }, [id]);

  const handleDelete = async () => {
    const confirmDelete = window.confirm("Are you sure you want to delete this service? This action cannot be undone.");
    if (!confirmDelete) return;

    try {
      await axios.delete(`${config.BASE_URL}/api/admin/services/${id}`, {
        withCredentials: true,
      });
      navigate("/admin/services");
    } catch (err) {
      setError("Failed to delete the service");
    }
  };

  // Language switching
  const switchLanguage = (lang) => {
    setActiveLanguage(lang);
  };

  // Get current language data
  const getCurrentLanguageData = () => {
    if (activeLanguage === "es" && service?.spanishData) {
      return {
        hero: {
          title: service.spanishData.hero?.title || "No Spanish title available",
          subtitle: service.spanishData.hero?.subtitle || "No Spanish subtitle available",
          paragraphs: service.spanishData.hero?.paragraphs || [],
          fileUrl: service.spanishData.hero?.fileUrl || "",
        },
        statistics: {
          ledStrips: {
            number: service.spanishData.statistics?.ledStrips?.number || "—",
            description: service.spanishData.statistics?.ledStrips?.description || "—",
          },
          retailSpace: {
            number: service.spanishData.statistics?.retailSpace?.number || "—",
            description: service.spanishData.statistics?.retailSpace?.description || "—",
          },
        },
      };
    }
    // Default to English
    return {
      hero: {
        title: service?.hero?.title || "No title available",
        subtitle: service?.hero?.subtitle || "No subtitle available",
        paragraphs: service?.hero?.paragraphs || [],
        fileUrl: service?.hero?.fileUrl || "",
      },
      statistics: {
        ledStrips: {
          number: service?.statistics?.ledStrips?.number || "—",
          description: service?.statistics?.ledStrips?.description || "—",
        },
        retailSpace: {
          number: service?.statistics?.retailSpace?.number || "—",
          description: service?.statistics?.retailSpace?.description || "—",
        },
      },
    };
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p>{error}</p>;
  if (!service) return <p>No service data found.</p>;

  const currentData = getCurrentLanguageData();
  const hasSpanishData = service.spanishData && (
    service.spanishData.hero?.title ||
    service.spanishData.hero?.subtitle ||
    service.spanishData.hero?.paragraphs?.length > 0 ||
    service.spanishData.statistics?.ledStrips?.number ||
    service.spanishData.statistics?.ledStrips?.description ||
    service.spanishData.statistics?.retailSpace?.number ||
    service.spanishData.statistics?.retailSpace?.description
  );

  return (
    <div className="dashboard service_detail_wrap">
      <div className="container">
        <h1 className="dash_title">Service Details</h1>
        <div className="back_btn_wrap">
          <button className="back-btn" onClick={() => navigate(-1)}>
            Go Back
          </button>
        </div>
        <div className="main-section">
          <div className="projects-inner">
            {/* Language Tabs - Only show if Spanish data exists */}
            {hasSpanishData && (
              <div className="language-tabs" style={{ marginBottom: "20px" }}>
                <button
                  type="button"
                  className={`language-tab ${activeLanguage === "en" ? "active" : ""}`}
                  onClick={() => switchLanguage("en")}
                  style={{
                    padding: "10px 20px",
                    marginRight: "10px",
                    backgroundColor: activeLanguage === "en" ? "#007bff" : "#f8f9fa",
                    color: activeLanguage === "en" ? "white" : "black",
                    border: "1px solid #ddd",
                    cursor: "pointer",
                    borderRadius: "4px",
                  }}
                >
                  English
                </button>
                <button
                  type="button"
                  className={`language-tab ${activeLanguage === "es" ? "active" : ""}`}
                  onClick={() => switchLanguage("es")}
                  style={{
                    padding: "10px 20px",
                    backgroundColor: activeLanguage === "es" ? "#007bff" : "#f8f9fa",
                    color: activeLanguage === "es" ? "white" : "black",
                    border: "1px solid #ddd",
                    cursor: "pointer",
                    borderRadius: "4px",
                  }}
                >
                  Spanish
                </button>
              </div>
            )}

            {/* Current Language Indicator */}
            <div style={{ marginBottom: "15px" }}>
              <span style={{ fontSize: "14px", color: "#666", fontWeight: "bold" }}>
                Viewing: {activeLanguage === "en" ? "English" : "Spanish"} Content
              </span>
            </div>

            {/* Hero Section */}
            <div className="detail_item">
              <h2>Hero Section</h2>
              <div className="detail_item_inner">
                <p><b>Title:</b> {currentData.hero.title}</p>
                <p><b>Subtitle:</b> {currentData.hero.subtitle}</p>
                <p>
                  <b>Description:</b>{" "}
                  {Array.isArray(currentData.hero.paragraphs) && currentData.hero.paragraphs.length > 0
                    ? currentData.hero.paragraphs.join(", ")
                    : "—"}
                </p>
                {/* {currentData.hero.fileUrl && (
                  <div className="banner_img_wrap">
                    <img
                      src={`${config.BASE_URL}${currentData?.hero?.fileUrl}`}
                      alt="Hero"
                      style={{ maxWidth: "400px", borderRadius: "8px", marginTop: "10px" }}
                    />
                  </div>
                )} */}
              </div>
            </div>

            {/* Statistics Section */}
            <div className="detail_item">
              <h2>Statistics</h2>
              <div className="detail_item_inner">
                <div>
                  <h4>LED Strips</h4>
                  <p><b>Number:</b> {currentData.statistics.ledStrips.number}</p>
                  <p><b>Description:</b> {currentData.statistics.ledStrips.description}</p>
                </div>
                <div style={{ marginTop: "10px" }}>
                  <h4>Retail Space</h4>
                  <p><b>Number:</b> {currentData.statistics.retailSpace.number}</p>
                  <p><b>Description:</b> {currentData.statistics.retailSpace.description}</p>
                </div>
              </div>
            </div>

            
            {/* Service Metadata */}
            {/* <div className="detail_item">
              <h2>Service Information</h2>
              <div className="detail_item_inner">
                <p><strong>Primary Language:</strong> {service.language || "en"}</p>
                <p><strong>Has Spanish Translation:</strong> {hasSpanishData ? "Yes" : "No"}</p>
                {service.created_at && (
                  <p><strong>Created:</strong> {new Date(service.created_at).toLocaleDateString()}</p>
                )}
                {service.updated_at && (
                  <p><strong>Last Updated:</strong> {new Date(service.updated_at).toLocaleDateString()}</p>
                )}
              </div>
            </div> */}

            {/* Action Buttons */}
            <div className="detail_project_btn_wrap">
              <div className="detail_edit_del">
                <div className="btn_item">
                  <button
                    className="detail_btns"
                    onClick={handleDelete}
                    style={{ backgroundColor: "#dc3545" }}
                  >
                    Delete
                  </button>
                </div>
                <div className="btn_item">
                  <Link
                    to={`/admin/update-service/${service._id}`}
                    className="update_detail detail_btns"
                  >
                    Edit
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ServiceDetails;
